module.exports = __webpack_public_path__ + "img/ic_new.6bb2cb54.svg";